const getFirstInvalidField = (state, formGroupNames) => {
  let fieldName = "";
  formGroupNames.find((groupName) => {
    const invalidField = Object.keys(state[groupName] ?? {}).find(
      (fieldName2) => !state[groupName]?.[fieldName2]?.isValid
    );
    if (invalidField) {
      fieldName = invalidField;
      return true;
    }
    return false;
  });
  return fieldName;
};
export {
  getFirstInvalidField
};
//# sourceMappingURL=get-first-invalid-field.js.map
